import { Row, Col, Typography, Table } from "antd";
import { useEffect, useState } from "react";
import { getProcurementDetails, getSizingDetailsBySK } from "apis";
import useProcurementStore from "store/procurement_store";

const { Text } = Typography;

const InfraDetails = ({ PK }) => {
  const [commvaultNode, setCommvaultNode] = useState("");
  const [roboTshirtSize, setRoboTshirtSize] = useState("");
  const [cluster_tshirt_size, setCluster_tshirt_size] = useState("");

  const [cpu, setCpu] = useState("");
  const [ram, setRam] = useState("");
  const [storage, setStorage] = useState("");
  const [commVaultStage, setCommVaultStage] = useState({});

 const {  current_stage_data} =
    useProcurementStore((state) => ({
      current_stage_data: state?.current_stage_data,
    }));

  console.log("current_stage_data", current_stage_data);

  useEffect(() => {
    const fetchCommvaultDetails = async () => {
      try {
        const response = await getProcurementDetails(PK, "CommVault");
        if (response.success && response.data?.length) {
          const stageItem = response.data[0];
          setCommVaultStage(stageItem);
          console.log("stageItem",stageItem);
          setCluster_tshirt_size(stageItem?.cluster_tshirt_size || "");
          setCommvaultNode(stageItem.node || "");
        }
      } catch (error) {
        console.error("Error fetching CommVault details:", error);
      }
    };

    const fetchRoboDetails = async () => {
      try {
        const response = await getProcurementDetails(PK, "Sizing");
        if (response.success && response.data?.length) {
          const stageItem = response.data[0];
          const size = stageItem.estimated_tshirt_size || "";
          setRoboTshirtSize(size);

          // Extract number of nodes
          const match = size.match(/^(\d+)\sNODE\s(.*)$/);
          if (match) {
            const numNodes = parseInt(match[1], 10);
            const restOfSK = match[2]; // "PERFORMANCE MEDIUM Gen10"
            const skForLookup = `1 NODE ${restOfSK}`;

            const sizingResponse = await getSizingDetailsBySK(skForLookup);
            if (sizingResponse.success && sizingResponse.data) {
              const baseCpu = parseFloat(
                sizingResponse.data.num_cpu_cores || "0"
              );
              const baseRam = parseFloat(sizingResponse.data.ram || "0");
              const baseStorage = parseFloat(
                sizingResponse.data.storage || "0"
              );

              setCpu((baseCpu * numNodes).toString());
              setRam((baseRam * numNodes).toString());
              setStorage((baseStorage * numNodes).toString());
            }
          }
        }
      } catch (error) {
        console.error("Error fetching ROBO details:", error);
      }
    };

    fetchCommvaultDetails();
    fetchRoboDetails();
  }, [PK]);

  const columns = [
    {
      title: "New Nodes",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "T Shirt Size",
      dataIndex: "tshirtSize",
      key: "tshirtSize",
    },
    {
      title: "CPU",
      dataIndex: "cpu",
      key: "cpu",
    },
    {
      title: "RAM",
      dataIndex: "ram",
      key: "ram",
    },
    {
      title: "STORAGE",
      dataIndex: "storage",
      key: "storage",
    },
  ];

  const data = [
    {
      key: "1",
      type: "ROBO",
      tshirtSize: roboTshirtSize || "-",
      cpu: cpu || "-",
      ram: ram || "-",
      storage: storage || "-",
    },
    {
      key: "2",
      type: "CommVault",
      tshirtSize: commvaultNode? (commvaultNode + " Node " + cluster_tshirt_size) : "-",
      cpu: "-",
      ram: "-",
      storage: commvaultNode * 42.67,
    },
    // (commVaultStage?.stage_status === "Approved" &&
    //   commVaultStage?.storage_pool !== "") && {
    //     key: "3",
    //     type: "CommVault-Network",
    //     tshirtSize: commvaultNode || "-",
    //     cpu: "",
    //     ram: "",
    //     storage: commvaultNode * 42.67,
    //   },
  ].filter(Boolean);

   const columns1 = [
    {
      title: "Network",
      dataIndex: "type",
      key: "type",
      width: 100,
    },
    {
      title: "SFPs",
      dataIndex: "size",
      key: "size",
      width: 100,
    },
  ];

const data1 = [
   
    {
      key: "1",
      type: "Network",
      // tshirtSize: (commvaultNode + " " + cluster_tshirt_size) || "-",
    },
  ];
   
  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            bordered
          />
        </Col>
      </Row>

        <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
        <Col span={12}>
          <Table
            columns={columns1}
            dataSource={data1}
            pagination={false}
            bordered
          />
        </Col>
      </Row>
      {/* <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
        <Col span={24}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
            }}
          >
            <thead>
              <tr style={{ background: "#f6f6f6" }}>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                  Type
                </th>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                  T Shirt Size
                </th>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                  CPU
                </th>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                  RAM
                </th>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                  STORAGE
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  ROBO
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {roboTshirtSize || "-"}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {cpu || "-"}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {ram || "-"}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {storage || "-"}
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  CommVault
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {commvaultNode || "-"}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}></td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}></td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}></td>
              </tr>
              <tr>
                <td colSpan={5} style={{ paddingTop: "20px" }}>
                  &nbsp;
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row> */}
      {/* Switch Info Section -----Need to modify once data will be there*/}
      {/* <Row gutter={[16, 16]}>
        <Col span={12}>
          <div style={{ marginBottom: 16 }}>
            <Text strong>ROBO Switches</Text>
            <div
              style={{
                border: "1px solid #ccc",
                padding: "8px 12px",
                borderRadius: 4,
                background: "#f9f9f9",
                marginTop: 4,
              }}
            >
              Switch Make and Model
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <Text strong>Commvault Switches</Text>
            <div
              style={{
                border: "1px solid #ccc",
                padding: "8px 12px",
                borderRadius: 4,
                background: "#f9f9f9",
                marginTop: 4,
              }}
            >
              Switch Make and Model
            </div>
          </div>
        </Col>
      </Row> */}
    </>
  );
};

export default InfraDetails;
